import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	pageCreatedSuccessfully: {
		id: 'hub-home.navigation.new-page-created-successfully',
		defaultMessage: "''{value}'' created",
		description: 'New custom page created successfully',
	},
	addNewPage: {
		id: 'hub-home.navigation.add-new-page',
		defaultMessage: 'Add new page',
		description: 'Label for the add new custom page button in the drop down menu',
	},
	homeDropdown: {
		id: 'hub-home.navigation.home-dropdown',
		defaultMessage: 'Home',
		description: 'Label for the home dropdown in the top navigation',
	},
	publishButton: {
		id: 'hub-home.navigation.publish-button',
		defaultMessage: 'Publish',
		description: 'Label for the publish button in the top navigation',
	},
	publishButtonTooltip: {
		id: 'hub-home.navigation.publish-button.tooltip',
		defaultMessage: 'Publish changes',
		description: 'Label for the publish button tooltip in the top navigation',
	},
	closeButton: {
		id: 'hub-home.navigation.close-button',
		defaultMessage: 'Close',
		description: 'Label for the close button in the top navigation',
	},
	searchPlaceholder: {
		id: 'hub-home.navigation.search-placeholder',
		defaultMessage: 'Search by name',
		description: 'Placeholder text for the search input in the sidebar',
	},
	pagesSection: {
		id: 'hub-home.navigation.pages-section',
		defaultMessage: 'Pages',
		description: 'Label for the pages section in the sidebar',
	},
	homeMenuItem: {
		id: 'hub-home.navigation.home-menu-item',
		defaultMessage: 'Home',
		description: 'Home menu item in the menu sidebar',
	},
	themingButton: {
		id: 'hub-home.navigation.theming-button.non-final',
		defaultMessage: 'Theming',
		description: 'Label for the theming button in the top navigation',
	},
	homePageLayoutPublishedSuccess: {
		id: 'hub-home.home-page-layout.published-success',
		defaultMessage: 'Support site updated',
		description: 'Success message when home page layout is published',
	},
	viewSupportSite: {
		id: 'hub-home.home-page-layout.view-support-site',
		defaultMessage: 'View the support site',
		description: 'Action text to view the support site after publishing',
	},
	homePageLayoutPublishError: {
		id: 'hub-home.home-page-layout.publish-error',
		defaultMessage: "We couldn't publish your changes",
		description: 'Error message when home page layout fails to publish',
	},
	homePageLayoutPublishRetry: {
		id: 'hub-home.home-page-layout.publish-retry',
		defaultMessage: 'Try again',
		description: 'Action text to retry publishing home page layout',
	},
});

export default messages;
